(() => {
  const selector = '[data-ln-skinny-hero]';

  const selectedSwatch = (root) => root?.querySelector('[data-lp-b-swatch][aria-pressed="true"]') || null;

  const syncFeaturedColors = (root, swatch) => {
    if (!root || !swatch) return;
    root.querySelectorAll('[data-ln-skinny-featured-color]').forEach((button) => {
      const selected = button.dataset.lpBQuickSwatch === swatch.dataset.variantId;
      button.classList.toggle('is-active', selected);
      button.setAttribute('aria-pressed', String(selected));
    });
  };

  const syncPalette = (root, swatch) => {
    if (!root || !swatch) return;
    root.style.setProperty('--ln-skinny-accent', swatch.dataset.skinnyBackgroundAccent || '#c8a8ae');
  };

  const syncDuoMedia = (root) => {
    if (!root) return;
    const duoMedia = root.querySelector('[data-ln-skinny-duo-media]');
    const primaryImage = duoMedia?.querySelector('[data-ln-skinny-duo-primary-image]');
    const secondaryImage = duoMedia?.querySelector('[data-ln-skinny-duo-secondary-image]');
    if (!duoMedia || !primaryImage || !secondaryImage) return;

    const duoSelected = root.querySelector('[data-lp-b-purchase-mode="duo"][aria-pressed="true"]');
    const primarySource = selectedSwatch(root);
    const secondary = root.querySelector('[data-lp-b-secondary-swatch][aria-pressed="true"]');
    const gallery = root.querySelector('.ln-pillow-b-gallery');
    const productMediaSelected = !gallery || root.querySelector('[data-lp-b-product-thumb][aria-pressed="true"]');
    const secondarySource = secondary?.dataset.variantId
      ? root.querySelector(`[data-lp-b-swatch][data-variant-id="${CSS.escape(secondary.dataset.variantId)}"]`)
      : null;
    const shouldShow = Boolean(duoSelected && primarySource?.dataset.mediaSrc && secondarySource?.dataset.mediaSrc && productMediaSelected);

    root.classList.toggle('is-duo-media-active', shouldShow);
    duoMedia.hidden = !shouldShow;
    if (!shouldShow) return;

    const updateImage = (image, source) => {
      const src = source.dataset.mediaSrc;
      const srcset = source.dataset.mediaSrcset || '';
      if (image.dataset.currentSrc === src && image.dataset.currentSrcset === srcset) return;
      image.dataset.currentSrc = src;
      image.dataset.currentSrcset = srcset;
      image.fetchPriority = 'high';
      image.sizes = '(min-width: 750px) 31vw, 64vw';
      if (srcset) image.srcset = srcset;
      else image.removeAttribute('srcset');
      image.src = src;
    };

    updateImage(primaryImage, primarySource);
    updateImage(secondaryImage, secondarySource);
  };

  const syncState = (root) => {
    const swatch = selectedSwatch(root);
    syncFeaturedColors(root, swatch);
    syncPalette(root, swatch);
    syncDuoMedia(root);
  };

  const init = (root) => syncState(root);

  const initAll = () => document.querySelectorAll(selector).forEach(init);

  document.addEventListener('click', (event) => {
    const control = event.target.closest?.('[data-lp-b-swatch], [data-lp-b-quick-swatch], [data-lp-b-secondary-swatch], [data-lp-b-purchase-mode], [data-lp-b-product-thumb], [data-lp-b-gallery-media]');
    const root = control?.closest(selector);
    if (!root || !control) return;
    let swatch = control.matches('[data-lp-b-swatch]') ? control : null;
    if (!swatch && control.dataset.lpBQuickSwatch) {
      swatch = root.querySelector(`[data-lp-b-swatch][data-variant-id="${CSS.escape(control.dataset.lpBQuickSwatch)}"]`);
    }
    if (swatch) syncPalette(root, swatch);
    requestAnimationFrame(() => syncState(root));
  });

  document.addEventListener('luminova:pillow-commerce', () => {
    document.querySelectorAll(selector).forEach(syncState);
  });
  document.addEventListener('shopify:section:load', initAll);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll, { once: true });
  else initAll();
})();
